import Pickup320Card from "./Pickup320Card";
import Pickup320Details from "./Pickup320Details";
import "./pickup_320.css";

export default {
  id: "msig_pickup_320_1p",
  company: "MSIG ประกันภัย",
  productLine: "motor",
  categories: ["pickup"],
  nameTH: "Pickup คอกเสมอหัวเก๋ง (320)",
  description: "ประกันภัยประเภท 1 สำหรับรถกระบะ ≤4 ตัน (ซ่อมอู่, รวมส่วนลด CCTV)",
  accent: "#e11d48",
  expiresAt: "9999-12-31",
  card: Pickup320Card,
  detail: Pickup320Details,
  active: true,
};
